
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apparel/tailoring",
      function () {
        return require("private-next-pages/apparel/tailoring/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apparel/tailoring"])
      });
    }
  